import type { FighterType } from '@/shared/constants';

/**
 * Identifies which game mode is active.
 * 'dino' = default dinosaur mode (T-Rex vs Spinosaurus)
 * 'elonvsnikita' = custom mode with head overlays and separate stats
 */
export type GameMode = 'dino' | 'elonvsnikita';

export interface GameModeConfig {
  mode: GameMode;
  /** Display title shown on the title screen. */
  title: string;
  /** Subtitle shown below the title. */
  subtitle: string;
  /** FighterType used for stats recording for player 1 (left/trex body). */
  p1StatsKey: FighterType;
  /** FighterType used for stats recording for player 2 (right/spino body). */
  p2StatsKey: FighterType;
  /** Display name for player 1. */
  p1Name: string;
  /** Display name for player 2. */
  p2Name: string;
  /** Color used for player 1 name label. */
  p1Color: string;
  /** Color used for player 2 name label. */
  p2Color: string;
  /** Path to head image for player 1 (overlaid on dino head), or null for default. */
  p1HeadImage: string | null;
  /** Path to head image for player 2 (overlaid on dino head), or null for default. */
  p2HeadImage: string | null;
}

const DINO_CONFIG: GameModeConfig = {
  mode: 'dino',
  title: 'DINO KOMBAT',
  subtitle: 'T-REX  vs  SPINOSAURUS',
  p1StatsKey: 'trex',
  p2StatsKey: 'spinosaurus',
  p1Name: 'T-REX',
  p2Name: 'SPINOSAURUS',
  p1Color: '#2d8c2d',
  p2Color: '#8c2d2d',
  p1HeadImage: null,
  p2HeadImage: null,
};

const ELON_VS_NIKITA_CONFIG: GameModeConfig = {
  mode: 'elonvsnikita',
  title: 'DINO KOMBAT',
  subtitle: 'ELON  vs  NIKITA',
  p1StatsKey: 'elon',
  p2StatsKey: 'nikita',
  p1Name: 'ELON',
  p2Name: 'NIKITA',
  p1Color: '#2d8c2d',
  p2Color: '#8c2d2d',
  p1HeadImage: '/heads/elon_head.jpg',
  p2HeadImage: '/heads/nikita_head.jpg',
};

/** The active game mode config — set once at startup. */
let activeConfig: GameModeConfig = DINO_CONFIG;

export function setGameMode(mode: GameMode): void {
  activeConfig = mode === 'elonvsnikita' ? ELON_VS_NIKITA_CONFIG : DINO_CONFIG;
}

export function getGameConfig(): GameModeConfig {
  return activeConfig;
}
